import { gql } from '$lib/apollo';

const NOTIFICATION_ACCOUNT_FRAGMENT = gql`
  fragment NotificationAccountFragment on API_Account {
    id
    slug
    name
    avatar {
      original {
        url
      }
    }
  }
`;

const NOTIFICATION_GROUP_FRAGMENT = gql`
  fragment NotificationGroupFragment on API_Group {
    id
    slug
    title
    logo {
      original {
        url
      }
    }
  }
`;

export const GET_NOTIFICATIONS = gql`
  query GetNotifications($after: String) {
    currentSession {
      id
      notifications(after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            createdAt
            seenAt
            readAt
            message
            event {
              id
              type
              params
              recordType
              record {
                ... on API_ProductEvent {
                  id
                  group {
                    id
                    logo {
                      original {
                        url
                      }
                    }
                  }
                  product {
                    id
                    slug
                  }
                }
                ... on API_PurchasedProductEvent {
                  id
                  event {
                    id
                    group {
                      id
                      logo {
                        original {
                          url
                        }
                      }
                    }
                  }
                  product {
                    id
                    productSlug
                  }
                }
                ... on API_PurchasedProductTip {
                  id
                  sender {
                    ...NotificationAccountFragment
                  }
                }
                ... on API_PurchasedProduct {
                  id
                  seller {
                    ...NotificationAccountFragment
                  }
                  coaching {
                    id
                  }
                }
                ... on API_PurchasedProductCoachingSession {
                  id
                  coaching {
                    id
                    attendee {
                      ...NotificationAccountFragment
                    }
                    host {
                      ...NotificationAccountFragment
                    }
                  }
                }
                ... on API_PurchasedProductCoaching {
                  id
                  attendee {
                    ...NotificationAccountFragment
                  }
                  host {
                    ...NotificationAccountFragment
                  }
                }
                ... on API_PostReaction {
                  id
                  account {
                    ...NotificationAccountFragment
                  }
                  post {
                    id
                    slug
                    originalPost {
                      id
                      slug
                    }
                  }
                }
                ... on API_PostVote {
                  id
                  account {
                    ...NotificationAccountFragment
                  }
                  post {
                    id
                    slug
                    originalPost {
                      id
                      slug
                    }
                  }
                }
                ... on API_Group {
                  ...NotificationGroupFragment
                }
                ... on API_ProductGuideAuthor {
                  id
                  state
                  percentage
                  productGuide {
                    id
                    product {
                      id
                      slug
                      name
                    }
                  }
                }
                ... on API_GroupMember {
                  id
                  group {
                    ...NotificationGroupFragment
                  }
                }
                ... on API_GroupRequest {
                  id
                  group {
                    ...NotificationGroupFragment
                  }
                }
                ... on API_GroupInvite {
                  id
                  group {
                    ...NotificationGroupFragment
                  }
                }
                ... on API_Post {
                  id
                  slug
                  originalPost {
                    id
                    slug
                  }
                  author {
                    ...NotificationAccountFragment
                  }
                }
                ... on API_Follow {
                  id
                  account {
                    ...NotificationAccountFragment
                  }
                }
                ... on API_TestimonialRequest {
                  id
                  seller {
                    id
                    slug
                    name
                    avatar {
                      original {
                        url
                      }
                    }
                    cover {
                      original {
                        url
                      }
                    }
                  }
                  product {
                    id
                    slug
                    name
                    productType
                  }
                }
                ... on API_Testimonial {
                  id
                  feedback
                  sentiment
                  impression
                  customer {
                    id
                    slug
                    name
                    avatar {
                      original {
                        url
                      }
                    }
                    cover {
                      original {
                        url
                      }
                    }
                  }
                }
                ... on API_GiftCard {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
  ${NOTIFICATION_ACCOUNT_FRAGMENT}
  ${NOTIFICATION_GROUP_FRAGMENT}
`;

export const GET_NOTIFICATION_SETTINGS = gql`
  query GetNotificationSettings {
    currentSession {
      id
      discord {
        id
      }
      notificationSettings {
        email
        discord
        webPush
      }
    }
  }
`;
